import { GROCERIES_TAB_CHANGED } from '@shopDetails/actionTypes';
import { GROCERIES_TAB } from '@shopDetails/model';

export const showCatalog = () => ({
  type: GROCERIES_TAB_CHANGED,
  payload: GROCERIES_TAB.CATALOGS,
});

export const showSections = () => ({
  type: GROCERIES_TAB_CHANGED,
  payload: GROCERIES_TAB.SECTIONS,
});
